'use strict';

/**
* FUNCTION: deepGet( obj, props )
*	Deep get a nested property.
*
* @param {Object|Array} obj - input object
* @param {Array} props - list of properties defining a key path
* @returns {*} nested property value
*/
function deepGet( obj, props ) {
	var len = props.length,
		v = obj,
		i;

	for ( i = 0; i < len; i++ ) {
		if ( typeof v === 'object' && v !== null && v.hasOwnProperty( props[i] ) ) {
			v = v[ props[i] ];
		} else {
			return;
		}
	}
	return v;
} // end FUNCTION deepGet()


// EXPORTS //

module.exports = deepGet;
